module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('form', [_c('website', {
    ref: "website"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-space"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-width"
  }, [_c('div', [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "contact-form form-vertical"
  }, [_vm._m(0), _vm._v(" "), _c('div'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('Textarea', {
    attrs: {
      "rows": "8",
      "id": "ContactFormMessage",
      "cols": "60",
      "name": "contact[body]",
      "placeholder": "Your Message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid__item medium-up--one-half"
  }, [_c('Button', {
    staticClass: "btn",
    staticStyle: {
      "width": "12%"
    },
    attrs: {
      "label": "Send"
    }
  })], 1)], 1)]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('footerWebsite', {
    ref: "footerWebsite"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', {
    staticClass: "h2"
  }, [_vm._v("Drop Us A Line")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid__item medium-up--one-half"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "ContactFormName",
      "name": "contact[name]",
      "placeholder": "Name",
      "value": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid__item medium-up--one-half"
  }, [_c('input', {
    attrs: {
      "type": "email",
      "id": "ContactFormEmail",
      "name": "contact[email]",
      "placeholder": "Email",
      "autocorrect": "off",
      "autocapitalize": "off",
      "value": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid__item medium-up--one-half"
  }, [_c('input', {
    attrs: {
      "type": "tel",
      "id": "ContactFormPhone",
      "name": "contact[phone]",
      "pattern": "[0-9\\-]*",
      "placeholder": "Phone Number",
      "value": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('ul', {
    staticClass: "contact-address"
  }, [_c('li', [_c('i', {
    staticClass: "ad ad-map-marker-al"
  }), _c('p', [_vm._v("Samakhusi, Kathmandu")])]), _vm._v(" "), _c('li', {
    staticClass: "phone"
  }, [_c('i', {
    staticClass: "ad ad-phone-l"
  }), _c('p', [_vm._v("+91-9911437000")])]), _vm._v(" "), _c('li', {
    staticClass: "email"
  }, [_c('i', {
    staticClass: "ad ad-envelope-l"
  }), _c('p', [_vm._v("Info@lilpicks.com")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "follow-us"
  }, [_c('ul', {
    staticClass: "list--inline site-footer__social-icons social-icons"
  }, [_c('li', [_c('a', {
    staticClass: "social-icons__link",
    attrs: {
      "href": "https://www.facebook.com/lilpickscouture",
      "target": "_blank",
      "title": "Lilpicks on Facebook"
    }
  }, [_c('i', {
    staticClass: "ad ad-facebook-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon__fallback-text"
  }, [_vm._v("Facebook")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "social-icons__link",
    attrs: {
      "href": "https://www.instagram.com/lilpickscouture/",
      "target": "_blank",
      "title": "Lilpicks on Instagram"
    }
  }, [_c('i', {
    staticClass: "ad ad-instagram"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon__fallback-text"
  }, [_vm._v("Instagram")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06e1a68f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/contactUs.vue
// module id = 2021
// module chunks = 0